<template>
<div>
    <nav class="app-pagination">
        <ul class="pagination justify-content-center">
            <li :class="{ disabled: pagination.current_page <= 1 }" class="page-item">
                <a :class="{ disabled: pagination.current_page <= 1 }" :disabled="!!pagination.prev_page_url" class="page-link" href="javascript:void(0)"
                   @click.prevent="changePage(pagination.current_page - 1)">
                    &laquo; {{ __('pagination.previous') }}
                </a>
            </li>
            <li class="page-item" v-for="pageNumber in pagesNumber" :key="pageNumber" :class="{ active : (pageNumber === pagination.current_page)}">
                <a
                   class="page-link" href="javascript:void(0)"
                   @click.prevent="changePage(pageNumber)">{{ pageNumber }}</a>
            </li>
            <li :class="{ disabled: pagination.current_page === pagination.last_page }"  class="page-item">
                <a  :class="{ disabled: pagination.current_page === pagination.last_page}" :disabled="pagination.next_page_url === null" class="page-link"
                   href="javascript:void(0)" @click.prevent="changePage(pagination.current_page + 1)">
                    {{ __('pagination.next') }} &raquo;
                </a>
            </li>
        </ul>
    </nav>
</div>
</template>

<script>
export default {
    name: "paginationComponent",
    props: {
        pagination: {
            type: Object,
            required: true
        },
        offset: {
            type: Number,
            default: 4
        }
    },
    computed: {
        pagesNumber () {
            if (!this.pagination.to) {
                return []
            }
            let from = this.pagination.current_page - this.offset
            if (from < 1) {
                from = 1
            }
            let to = from + this.offset * 2
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page
            }
            let pagesArray = []
            for (let page = from; page <= to; page++) {
                pagesArray.push(page)
            }
            return pagesArray
        }
    },
    methods: {
        changePage (page) {
            this.pagination.current_page = page
            this.$emit('paginate')
        }
    }
}
</script>

<style scoped>

</style>
